module.exports = "images/doc-day-add-drag.b35f6d7eea13cb8b54727b69bc38d756.gif";